import type { Input } from "@/components/ui/input";
import { PasswordInput as SharedPasswordInput } from "@/shared/components/password-input";
import { type ComponentProps, forwardRef } from "react";

/**
 * Password input s přepínačem viditelnosti — sdílená implementace ze
 * `@/shared/components/password-input`, tady jen s auth `data-testid`,
 * na které se odkazují existující E2E selektory.
 */
export const PasswordInput = forwardRef<HTMLInputElement, ComponentProps<typeof Input>>(
  (props, ref) => <SharedPasswordInput ref={ref} toggleTestId="auth-password-toggle" {...props} />,
);
